$(document).ready(function() {

    // $fbIcon = $('.ttgFooterContainer .fa-facebook').closest('a').clone();
    // $fbIcon.prop({
    //     target: '_blank',
    //     id: 'fbLink'
    // }).find('i').addClass('fa-facebook-f').removeClass('fa-facebook').find('span').remove();
    //
    // $searchLink = $('<a />').prop({
    //     href: 'https://www.kultursommer-ooe.at/veranstaltungen',
    //     id: 'searchLink'
    // }).html('<i class="fas fa-search fa-fw"></i>');
    //
    // $dynamicHeaderLinks = $('<div />').prop('id', 'dynamicHeaderLinks').append($searchLink, $fbIcon);

    $dynamicHeaderLinks = $('<div />').prop('id', 'dynamicHeaderLinks').append('<a href="https://www.land-oberoesterreich.gv.at/" target="_blank"><img src="/fileadmin/projects/kultursommer/images/oberoesterreich_wappen.png" title="" alt="Land Oberösterreich – Startseite (neues Fenster)" /></a>');

    $('.ttgLogoMenuContainer .ttgLogo').closest('.row').append($dynamicHeaderLinks);

});